import { IGPSGetJobResultParsed } from "../Models/Models";
import { IBrand } from "../Models/IBrand";
import { IGCPBigQueryJob } from "../Models/IGCPBigQueryJob";
import { ISubmitMobilyticsJobRequest } from "../Models/Requests/ISubmitMobilyticsJobRequest";
import { IGetJobsRequest } from "../Models/Requests/IGetJobsRequest";

export interface IGPSInsightsAxios {
  GetResults(jobID: string): Promise<IGPSGetJobResultParsed>;
  GetBrand(term: string): Promise<IBrand>;
  GetUserJobs(request: IGetJobsRequest): Promise<IGCPBigQueryJob[]>;
  GetCompanyJobs(request: IGetJobsRequest): Promise<IGCPBigQueryJob[]>;
  GetJob(jobId: string): Promise<IGCPBigQueryJob>;
  // TODO: GB - resolve this any
  SubmitGpsReport(request: ISubmitMobilyticsJobRequest): Promise<any>;
}
